import { ThunkType } from "../../../../core/store/reducers";
import { getExchangeMembersExcel } from "../api/getExchangeMembersExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../exchangeMemberDataSlice";

export const downloadExchangeMemberExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchmembers;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getExchangeMembersExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "ExchangeMembers.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
